module.exports = __webpack_public_path__ + "static/media/cc.eaaed951.svg";